/**
 * Centralized API client for all API requests
 */
import axios from 'axios';
import Constants from '../Constants.json';

const apiClient = axios.create({
  baseURL: Constants.BACKEND_SERVER_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: Constants.APP_API_TIMEOUT || 200000,
});

// Request interceptor to add authentication token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expirationTime');
      localStorage.removeItem('role');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;



